<!-- Added automation IDs 19/10/2026 DW -->
@if (!item.navCap) {
  @if (item.route && (!item.children || !item.children.length)) {
    <a
      [id]="navItemAutomationId()"
      class="cursor-pointer menuLink"
      [routerLink]="item.route"
      routerLinkActive="activeMenu"
      [routerLinkActiveOptions]="{ exact: false }"
    >
      <i-tabler class="routeIcon icon-18" name="{{ item.iconName }}"></i-tabler>
      {{ item.displayName }}
    </a>
  } @else {
    <a [id]="navItemAutomationId()" class="cursor-pointer menuLink">
      <i-tabler class="routeIcon icon-18" name="{{ item.iconName }}"></i-tabler>
      {{ item.displayName }}
      @if (item.children && item.children.length) {
        <span class="down-icon d-flex m-l-auto">
          <mat-icon> expand_more </mat-icon>
        </span>
      }
    </a>
  }
}
@if (item.children) {
  <div class="childBox">
    @for (child of item.children; track child) {
      <app-horizontal-nav-item [item]="child" class="ddmenu">
      </app-horizontal-nav-item>
    }
  </div>
}
